import { IconAlertTriangleFilled } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

interface FailedAlertMessageProps {
  children: React.ReactNode;
}

const FailedAlertMessage: React.FC<FailedAlertMessageProps> = ({
  children,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <IconAlertTriangleFilled className="text-feedback-warning-base! size-4!" />
      {t('TrainingPlans.compliancePlanNotPassed')}
      {children}
    </>
  );
};

export default FailedAlertMessage;
